<template>
  <div class="flex items-center">
    <div class="relative flex items-center cursor-pointer">
      <select id="localeSwitcher" v-model="selectedLocale" @change="updateLanguage"
        class="appearance-none outline-none w-20 cursor-pointer"> {{selectedLocale}}
        <option :value="locale.code" v-for="locale in locales" :key="locale.code">
          {{ locale.name }}
        </option>
      </select>
        <dropdown-arrow class="right-0 absolute pointer-events-none" />
    </div>
  </div>
</template>

<script>
import { getSupportedLocales } from '@/util/i18n/supported-locales';
import DropdownArrow from '@/components/graphics/DropdownArrow.vue';
import { mapActions, mapGetters } from 'vuex';
import TranslationsMixin from '@/mixins/TranslationsMixin';

export default {
  data() {
    return {
      showSwitcher: false,
      locales: [],
      selectedLocale: '',
    };
  },

  components: {
    DropdownArrow,
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
      user: 'auth/user',
    }),
  },

  created() {
    getSupportedLocales().then(({ data }) => {
      this.locales = data;
    });
  },

  mounted() {
    this.selectedLocale = this.$i18n.locale;
  },

  watch: {
    changedLocale() {
      this.selectedLocale = this.$i18n.locale;
    },
  },

  mixins: [TranslationsMixin],

  methods: {
    ...mapActions({
      changeLocale: 'auth/changeLocale',
    }),

    toggleSwitcher() {
      this.showSwitcher = !this.showSwitcher;
    },

    closeSwitcher() {
      this.showSwitcher = false;
    },

    updateLanguage() {
      this.$i18n.locale = this.selectedLocale;
      this.changeLocale();
      this.$store.dispatch('auth/auth');
      if (this.user) {
        this.updateUserLanguage(this.selectedLocale, true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  @apply uppercase; @apply font-serif; @apply mb-2;
}

select {
  @apply px-2; @apply py-1
}
</style>
